module.exports = __webpack_public_path__ + "img/yilianGl18.91769d77.png";